import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import axios from 'axios'

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/download',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/upload',
    name: 'upload',
    meta: { requiresAuth: true, allowedAuth: [0] },
    component: () => import(/* webpackChunkName: "about" */ '../views/UploadView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegisterView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyView.vue')
  },
  {
    path: '/manage',
    name: 'manage',
    meta: { requiresAuth: true, allowedAuth: [0] },
    component: () => import(/* webpackChunkName: "about" */ '../views/ManageView.vue')
  },
  {
    path: '/members',
    name: 'members',
    meta: { requiresAuth: true, allowedAuth: [0] },
    component: () => import(/* webpackChunkName: "about" */ '../views/MemberView.vue')
  },
  {
    path: '/payments',
    name: 'payments',
    meta: { requiresAuth: true, allowedAuth: [0] },
    component: () => import('../views/PaymentView.vue')
  },
  {
    path: '/clients',
    name: 'clients',
    meta: { requiresAuth: true, allowedAuth: [0, 1] },
    component: () => import('../views/ClientsView.vue')
  },
  {
    path: '/clients/:siteName',
    name: 'clientDetail',
    meta: { requiresAuth: true, allowedAuth: [0, 1] },
    component: () => import('../views/ClientDetailView.vue')
  },
  {
    path: '/error404',
    name: 'error404',
    component: () => import(/* webpackChunkName: "about" */ '../views/Error404View.vue')
  },
  {
    path: '/error500',
    name: 'error500',
    component: () => import(/* webpackChunkName: "about" */ '../views/Error500View.vue')
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import(/* webpackChunkName: "about" */ '../views/MaintenanceView.vue')
  },
  {
    path: '/mypage',
    name: 'mypage',
    meta: { requiresAuth: true, allowedAuth: [0, 2] },
    component: () => import(/* webpackChunkName: "about" */ '../views/MyPageView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { requiresAuth: true, allowedAuth: [0, 1] },
    component: () => import(/* webpackChunkName: "about" */ '../views/DashboardView.vue')
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import(/* webpackChunkName: "about" */ '../views/PricingView.vue')
  },
  {
    path: '/provision',
    name: 'provision',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProvisionView.vue')
  },
  {
    path: '/audit',
    name: 'audit',
    meta: { requiresAuth: true, allowedAuth: [0, 1] },
    component: () => import('../views/AuditLogView.vue')
  },
  {
    path: '/inquiry',
    name: 'inquiry',
    meta: { requiresAuth: true, allowedAuth: [0, 1] },
    component: () => import('../views/InquiryRequestView.vue')
  },
  {
    path: '/notification',
    name: 'notification',
    meta: { requiresAuth: true, allowedAuth: [0, 1] },
    component: () => import('../views/NotificationView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackChunkName: "about" */ '../views/Error404View.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth) return true

  try {
    const res = await axios.get('/api/session')
    if (!res.data?.user) return { name: 'login' }

    if (to.meta.allowedAuth && !to.meta.allowedAuth.includes(res.data.user.auth)) {
      return { name: 'home' }
    }

    return true
  } catch {
    return { name: 'login' }
  }
})

export default router
